import { AgentState, UnavailableCode } from '../../types';

/** Tenant-specific ACW unavailable reasons often use labels like "Wrap Up" instead of "ACW". */
function reasonLooksLikeAcw(reason: string | null | undefined): boolean {
  const normalized = reason?.toLowerCase() ?? '';
  return normalized.includes('acw') || normalized.includes('wrap');
}

export function resolveIsInAcwState(
  isInAcw: boolean,
  agentState: AgentState,
  unavailableCodes: UnavailableCode[]
): boolean {
  if (isInAcw) {
    return true;
  }

  if (agentState.state?.toLowerCase() !== 'unavailable') {
    return false;
  }

  if (reasonLooksLikeAcw(agentState.reason)) {
    return true;
  }

  if (!agentState.reasonCode) {
    return false;
  }

  const matchingCode = unavailableCodes.find((code) => code.outStateId === agentState.reasonCode);
  return matchingCode?.isACW ?? false;
}
